import { Placement } from '@floating-ui/react'
import { HTMLMotionProps } from 'motion/react'

export function simpleExpandFromOrigin(placement: Placement): HTMLMotionProps<'div'> {
	return {
		initial: {
			opacity: 0,
			translateX: placement === 'left' ? 6 : placement === 'right' ? -6 : 0,
			translateY: placement === 'top' ? 6 : placement === 'bottom' ? -6 : 0,
			scale: 0.8,
		},
		animate: {
			opacity: 1,
			translateX: 0,
			translateY: 0,
			scale: 1,
		},
		exit: {
			opacity: 0,
			translateX: placement === 'left' ? 6 : placement === 'right' ? -6 : 0,
			translateY: placement === 'top' ? 6 : placement === 'bottom' ? -6 : 0,
			scale: 0.8,
		},
		style: {
			originX: placement === 'left' ? 1 : placement === 'right' ? 0 : 0.5,
			originY: placement === 'top' ? 1 : placement === 'bottom' ? 0 : 0.5,
		},
	}
}
